module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/support-c02e8f4b227d29bcc1ae5bcfb4a88996.png";